/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class AgentCompatibilityAreaEnum.
* @enum {}
* @readonly
*/
export default class AgentCompatibilityAreaEnum {
    
        /**
         * value: "関東"
         * @const
         */
        "関東" = "関東";

    
        /**
         * value: "関西中京"
         * @const
         */
        "関西中京" = "関西中京";

    
        /**
         * value: "九州"
         * @const
         */
        "九州" = "九州";

    
        /**
         * value: "その他地方"
         * @const
         */
        "その他地方" = "その他地方";

    
        /**
         * value: "全国対応"
         * @const
         */
        "全国対応" = "全国対応";

    

    /**
    * Returns a <code>AgentCompatibilityAreaEnum</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/AgentCompatibilityAreaEnum} The enum <code>AgentCompatibilityAreaEnum</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

